import { LOGIN_TYPES } from '../../constants'
import { fetchToken, _fetchTokenFn, toLogin, toSignOut, token, getToken, setToken, initWorkWxRouterGuard as routerGuard } from './loginUtils'

const createLoginExample = () => ({
  LoginType: LOGIN_TYPES.WORK_WECHAT_WEB,
  token,
  getToken,
  setToken,
  toLogin,
  logout: toSignOut,
  fetchToken,
  routerGuard
})

const initAlphaLogin = () => {
  // ...执行 plugin
  const destoryFn = () => {

  }
  return [createLoginExample(), destoryFn]
}

export default initAlphaLogin